/**
 * Photo Reviews Frontend - Free Version
 */
(function ($) {
  'use strict';

  function format(template, ...values) {
    let i = 0;
    return template.replace(/%\d?\$?[ds]/g, () => values[i++]);
  }

  function init() {
    const wrapper = document.querySelector('.revoty-photo-upload-field');
    if (!wrapper) return;

    const input = wrapper.querySelector('input[type="file"]');
    const errorEl = wrapper.querySelector('.revoty-upload-error');
    if (!input) return;

    const settings = window.revotyPhotoReviews || {};
    const maxPhotos = parseInt(wrapper.dataset.maxPhotos, 10) || settings.maxPhotos || 5;
    const maxSizeMb = parseInt(wrapper.dataset.maxSizeMb, 10) || settings.maxFileSizeMb || 5;
    const required = wrapper.dataset.required === '1';
    const i18n = settings.i18n || {};

    const showError = (msg) => {
      if (errorEl) errorEl.textContent = msg;
    };
    const clearError = () => showError('');

    const validateFiles = (files) => {
      if (files.length > maxPhotos) {
        return format(i18n.tooManyPhotos || 'You can upload up to %d photos.', maxPhotos);
      }
      const maxBytes = maxSizeMb * 1024 * 1024;
      for (const f of files) {
        if (f.size > maxBytes) {
          return format(i18n.fileTooLarge || '"%s" exceeds %d MB.', f.name, maxSizeMb);
        }
      }
      return '';
    };

    input.addEventListener('change', () => {
      clearError();
      const error = validateFiles(input.files);
      if (error) {
        showError(error);
        input.value = '';
      }
    });

    const form = input.closest('form');
    if (form) {
      form.addEventListener('submit', (e) => {
        clearError();
        if (required && (!input.files || input.files.length === 0)) {
          e.preventDefault();
          showError(i18n.photoRequired || 'Please upload at least one photo.');
          input.focus();
          return;
        }
        const error = validateFiles(input.files);
        if (error) {
          e.preventDefault();
          showError(error);
          input.focus();
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})(jQuery);
